// Lands the user on a fresh page after they click the password-reset link
// in the email Better Auth sent. The link looks like:
//   https://stage.kaijaalliksaar.ee/auth/confirm?token=<token>
// We read the token here and hand it to PasswordUpdateForm via router state
// so the form can call resetPassword({ token, newPassword }) without a
// session — Better Auth validates the token server-side.

import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Loader2 } from "lucide-react";

const AuthConfirm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) return;
    navigate("/auth", {
      replace: true,
      state: {
        showPasswordUpdate: true,
        fromTokenVerification: true,
        resetToken: token,
      },
    });
  }, [token, navigate]);

  if (!token) {
    return (
      <div className="container max-w-md mx-auto px-4 py-8 flex items-center justify-center min-h-[50vh]">
        <Alert variant="destructive">
          <AlertDescription>
            Token puudub. Palun proovi uuesti parooli lähtestada.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className="container max-w-md mx-auto px-4 py-8 flex items-center justify-center min-h-[50vh]">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p>Suuname parooli vahetuse vormile...</p>
      </div>
    </div>
  );
};

export default AuthConfirm;
